module.exports = __webpack_public_path__ + "img/qrcode.2446e17a.svg";